import { useSaveLeadNotificationEmailsMutation } from "../../../../../../api/mutations/useSaveLeadNotificationEmailsMutation";
import { uiNotification } from "../../../../../../services/UINotificationService";

export const useSubmit = () => {
  const { mutateAsync, isLoading } = useSaveLeadNotificationEmailsMutation({
    onError: () => {
      uiNotification.error("Failed to save emails");
    },
    onSuccess: () => {
      uiNotification.success("Emails have been successfully saved");
    },
  });

  return {
    initiate: (emails) => mutateAsync({ emails }),
    isLoading,
  };
};
